/* eslint-disable @typescript-eslint/no-unused-vars */
import CountdownV2 from "components/CountdownV2";
import {
	Background,
	bannerStyle,
	Container,
	CrossOutValue,
	ButtonContainer,
	DataContainer,
	InfoButton,
	CrossOutContainer,
	ItemImage,
	Items,
	LoyaltyContainer,
	LoyaltyPoints,
	OfferItem,
	RewardAmount,
	RewardAmountContainer,
	RewardItem,
	SubTitle,
	textStyle,
	CustomButton
} from "./styles";
import BonusFlag from "components/BonusFlag";
import { useGoogleAnalyticsContext, useWebStoreContext } from "contexts";
import { IShopLoyaltyOffer } from "contexts/WebStoreProvider/types";
import { useEffect, useRef, useState } from "react";
import { useDialogModalRedux } from "redux/slices/dialog/hooks/useDialogModalRedux";
import { useAppDispatch, useAppSelector } from "hooks";
import { useSelector } from "react-redux";
import { offersApi } from "redux/apis";
import { RootState } from "redux/store";
import useRewardsById from "hooks/useRewardsById";
import classNames from "classnames";
import { WsDialogs } from "interfaces";
import { Snackbar, Typography, useMediaQuery } from "@mui/material";
import { getVariantImage } from "helpers/getVariantImage";
import { sortBundleRewards } from "helpers/rewardSort";
import { crownWhiteIconPath as crownIconPath, CrownIcon } from "utils/svgIcons";
import {
	onDIPtrigger,
	selectDipState,
	setPricePoint,
	setTriggerOnCache
} from "redux/slices";

const LoyaltyOfferCardV2 = ({
	className,
	data,
	backgroundImageUrl
}: {
	uniqueKey?: string;
	className?: string;
	data: IShopLoyaltyOffer;
	backgroundImageUrl: string;
}): JSX.Element => {
	const { authToken, userTracker, setActiveItemToBeClicked } =
		useWebStoreContext();
	const {
		syncUserTracker,
		setCurrentOffer,
		openLoginToContinueDialog,
		currentOffer,
		networkErrorDetected
	} = useWebStoreContext();

	const itemRef = useRef<HTMLDivElement>(null);

	const { reportLoyaltyPurchaseEvent } = useGoogleAnalyticsContext();
	const { openDialog } = useDialogModalRedux();
	const [snackbarOpen, setSnackbarOpen] = useState(false);
	const [isCurrentOffer, setIsCurrentOffer] = useState<boolean>(false);
	const buyButtonRef = useRef(null);
	const dispatch = useAppDispatch();
	const { nowTime } = useWebStoreContext();
	const showOfferId = useSelector(
		(state: RootState) => state.debug.showDebugLabels
	);
	const { data: dipsData } = useAppSelector(selectDipState);
	const {
		id: offerId,
		rewardId,
		bannerText,
		//description,
		loyaltyPointPrice: price,
		priority,
		sectionName,
		rewardImageUrl,
		endTime,
		campaignGroup,
		crossOutValue,
		timer
	} = data;

	const isPortrait = useMediaQuery("(max-width:649px)");

	const displayRewards = useRewardsById(rewardId);

	const resetCurrentOffer = () => {
		setIsCurrentOffer(false);
		setCurrentOffer(null);
	};

	const getRewardDescription = () => {
		const reward = displayRewards?.[0];
		const value = Number(reward?.description?.replace(/[^0-9]/g, ""));
		const label = value > 1 ? reward?.pluralLabel : reward?.singularLabel;
		return `${value.toLocaleString("en-US")} ${label}`;
	};

	const onClose = () => {
		resetCurrentOffer();
		reportLoyaltyPurchaseEvent(
			"loyalty_purchase_cancelled",
			userTracker?.id as string,
			endTime,
			offerId,
			rewardId,
			priority,
			price,
			campaignGroup,
			sectionName
		);
		if (
			dipsData?.dips?.find(
				(obj) => obj.dip.triggerType === "purchaseCancelled-loyalty_points"
			)
		) {
			price && dispatch(setPricePoint(price));
			dispatch(setTriggerOnCache("purchaseCancelled-loyalty_points"));
		} else {
			dispatch(onDIPtrigger({ triggerType: "purchaseCancelled" }));
		}
	};

	const handleOnEnd = () => {
		dispatch(offersApi.util.invalidateTags(["offersTag"]));
	};

	useEffect(() => {
		if (currentOffer === buyButtonRef.current) {
			setIsCurrentOffer(true);
		} else {
			setIsCurrentOffer(false);
		}
	}, [currentOffer]);

	const onClickConfirmBuy = async () => {
		reportLoyaltyPurchaseEvent(
			"loyalty_purchase_started",
			userTracker?.id as string,
			endTime,
			offerId,
			rewardId,
			priority,
			price,
			campaignGroup,
			sectionName
		);
		setCurrentOffer(buyButtonRef.current);

		let latestUserTracker = userTracker;
		if (networkErrorDetected) {
			const userTrackerResponse = await syncUserTracker();
			if (userTrackerResponse) {
				latestUserTracker = userTrackerResponse.userTracker;
			}
		}

		if (!authToken?.value) {
			setActiveItemToBeClicked({
				type: "loyalty_offer",
				offerId,
				description: getRewardDescription(),
				price,
				data,
				rewardImageUrl,
				cbClose: onClose
			});
			openLoginToContinueDialog();
		} else if (
			// intercept insufficient points before making request
			typeof latestUserTracker?.loyaltyPoints !== "undefined" &&
			latestUserTracker.loyaltyPoints < price
		) {
			openDialog(WsDialogs.INSUFFICIENT_LOYALTY_POINT_BALANCE, {
				cbClose: resetCurrentOffer,
				NeededLoyaltyPoints: price,
				CurrentLoyaltyPoints: latestUserTracker?.loyaltyPoints
			});
		} else {
			openDialog(WsDialogs.LOYALTY_PURCHASE_CONFIRM, {
				offerId,
				itemDescription: getRewardDescription(),
				itemPrice: price,
				itemImageUrl: rewardImageUrl,
				data,
				cbClose: onClose
			});
		}
	};

	const handleCopyOfferId = () => {
		navigator.clipboard.writeText(offerId);
		setSnackbarOpen(true);
	};

	return (
		<Container
			id={offerId}
			data-testid="featuredCard"
			key={offerId}
			backgroundImageUrl={getVariantImage(
				rewardImageUrl,
				"{image_variant_1}",
				isPortrait ? "small" : "large"
			)}
		>
			{endTime && timer && (
				<CountdownV2
					text="Offer ends in:"
					startTime={nowTime}
					endTime={endTime}
					onEnd={handleOnEnd}
					style={{ padding: "0.2em 0.5em", top: "0.5em" }}
					//iconStyle={}
					//labelStyle={}
				/>
			)}
			<BonusFlag
				text={bannerText}
				position="right"
				bannerStyle={bannerStyle}
				textStyle={textStyle}
			/>
			{showOfferId && (
				<>
					<Typography
						onClick={handleCopyOfferId}
						sx={{
							position: "absolute",
							fontWeight: 700,
							color: "red",
							fontSize: "0.9em",
							bottom: "0.1em",
							width: "100%",
							display: "flex",
							justifyContent: "center",
							cursor: "pointer"
						}}
					>
						{offerId}
					</Typography>
					<Snackbar
						open={snackbarOpen}
						autoHideDuration={2000}
						onClose={() => setSnackbarOpen(false)}
						message="Offer ID copied to clipboard"
					/>
				</>
			)}

			<DataContainer>
				<OfferItem>
					<Items>
						{sortBundleRewards(displayRewards).map(
							({ imageUrl, description }, key) => {
								return (
									<RewardItem
										className="imgWrap"
										key={key}
										width={100 / displayRewards.length + "%"}
									>
										<ItemImage src={imageUrl} alt="" />
										<RewardAmountContainer>
											<RewardAmount>{description}</RewardAmount>
										</RewardAmountContainer>
									</RewardItem>
								);
							}
						)}
					</Items>
				</OfferItem>
				<ButtonContainer>
					<CrossOutContainer>
						<CrossOutValue>
							<CrownIcon
								width={"1em"}
								height={"1em"}
								//style={{ marginRight: "0.3em" }}
							/>
							{crossOutValue && Number(crossOutValue)?.toLocaleString("en-US")}
						</CrossOutValue>
					</CrossOutContainer>
					<CustomButton
						//id={`buy-button-${offerId}`}
						ref={buyButtonRef}
						variant="contained"
						color="success"
						size="large"
						onClick={onClickConfirmBuy}
						className={classNames({
							isCurrentOfferSet: !isCurrentOffer && !!currentOffer,
							isCurrentOffer: !!isCurrentOffer
						})}
					>
						<CrownIcon width={"1.1em"} height={"1.1em"} />
						{Number(price).toLocaleString("en-US")}
					</CustomButton>
				</ButtonContainer>
			</DataContainer>
		</Container>
	);
};

export default LoyaltyOfferCardV2;
